package co.maytes.standupbot.dashboard.styles

import co.maytes.standupbot.dashboard.components.widgets.cssRgb
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import org.jetbrains.compose.web.css.CSSMediaQuery
import org.jetbrains.compose.web.css.StyleScope
import org.jetbrains.compose.web.css.percent

object SettingsClasses {
    const val GROUND_CANVAS = "sb-ground-canvas"
    const val PILL_HOST = "sb-nav-pill-host"
    const val PILL = "sb-nav-pill"
    const val PILL_INSTANT = "sb-nav-pill-instant"
    const val FLASH = "sb-setting-flash"
    const val BAR = "sb-bar"
    const val ROW = "sb-setting-row"
}

private fun InitSilkContext.rule(selector: String, build: StyleScope.() -> Unit) {
    stylesheet.registerStyle(selector) { base { Modifier.styleModifier(build) } }
}

@InitSilk
fun initSettingsStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerKeyframes("sb-setting-ring") {
        0.percent {
            Modifier.styleModifier { property("outline-color", Palette.accent.cssRgb()) }
        }
        100.percent {
            Modifier.styleModifier { property("outline-color", "transparent") }
        }
    }

    ctx.rule(".${SettingsClasses.GROUND_CANVAS}") {
        property("background-color", Palette.canvas.cssRgb())
    }
    ctx.rule(".${SettingsClasses.PILL_HOST}") {
        property("position", "relative")
    }
    ctx.rule(".${SettingsClasses.PILL}") {
        property("position", "absolute")
        property("left", "0")
        property("right", "0")
        property("top", "0")
        property("height", "0")
        property("opacity", "0")
        property("border-radius", Radius.md.toString())
        property("background-color", Palette.active.cssRgb())
        property("pointer-events", "none")
        property("transform", "translateY(0)")
        property("transition", Motion.transitionWith(Motion.DUR_PILL, Motion.EASE_EMPHASIS, "transform", "height", "opacity"))
    }
    ctx.rule(".${SettingsClasses.PILL}.${SettingsClasses.PILL_INSTANT}") {
        property("transition", "none")
    }
    ctx.rule(".${SettingsClasses.FLASH}") {
        property("outline", "${FocusRing.WIDTH_PX}px solid ${Palette.accent.cssRgb()}")
        property("outline-offset", FocusRing.OFFSET)
        property("animation", "sb-setting-ring ${Motion.DUR_FLASH} ${Motion.EASE_EMPHASIS} both")
    }
    ctx.rule(".${SettingsClasses.BAR}") {
        property("background-color", Palette.borderSubtle.cssRgb())
        property("border-radius", Radius.inner.toString())
        property("color", "transparent")
    }

    ctx.stylesheet.registerStyle(".${SettingsClasses.ROW}") {
        base {
            Modifier.styleModifier {
                property("display", "grid")
                property("grid-template-columns", "minmax(14rem, 25rem) minmax(0, 1fr)")
                property("column-gap", Spacing.xl.toString())
                property("row-gap", Spacing.md.toString())
            }
        }
        cssRule(CSSMediaQuery.Raw("(max-width: 1099px)"), null) {
            Modifier.styleModifier {
                property("grid-template-columns", "minmax(0, 1fr)")
            }
        }
    }

    ctx.reducedMotionRule(".${SettingsClasses.PILL}") { property("transition", "none !important") }
    ctx.reducedMotionRule(".${SettingsClasses.FLASH}") { property("animation", "none !important") }
}
